import React from 'react';
import { useField } from 'formik';
import { formatPriceWithSymbol, getCurrencyCode, getCurrencyDecimals } from '../../../utils/currency';

const CurrencyInput = ({ label, ...props }) => {
  const [field, meta, helpers] = useField(props);

  // Campo de DIGITACAO: mostra so a moeda de cobranca, nunca a conversao dupla.
  //
  // O texto que esta funcao devolve volta a ser o VALOR do input, e a tecla
  // seguinte roda replace(/\D/g) sobre ele. Com a exibicao dupla ligada o campo
  // valia "$10.00 (~LBP 900)", os digitos da lira entravam na conta e o numero
  // explodia a cada tecla -- digitar "10000" virava LBP 99.891.899.019.899.020.000.000.
  // Passar o codigo da moeda no 2o argumento faz o formatPriceWithSymbol
  // devolver so a principal.
  const formatCurrency = (value) => {
    if (!value) return '';

    const cleanedValue = String(value).replace(/\D/g, '');
    if (!cleanedValue) return '';

    // Divisor pelas casas da moeda: em moeda sem centavo (LBP) o que foi digitado
    // ja e o valor inteiro, e dividir por 100 daria um centesimo do que o
    // operador viu na tela.
    const divisor = Math.pow(10, getCurrencyDecimals());
    const numericValue = parseInt(cleanedValue, 10);

    return formatPriceWithSymbol(numericValue / divisor, getCurrencyCode());
  };

  const handleChange = (event) => {
    const inputValue = event.target.value;
    const formattedValue = formatCurrency(inputValue);
    helpers.setValue(formattedValue);
  };

  return (
    <div className="input-box">
      <input
        {...field}
        {...props}
        onChange={handleChange}
      />
      {meta.touched && meta.error ? (
        <div className="error-message">{meta.error}</div>
      ) : null}
    </div>
  );
};

export default CurrencyInput;
